import { Order } from 'entities/orders/model/types';
import { FC } from 'react';
import { OrderPersonInfo } from '../PersonInfo/OrderPersonInfo';
import { OrderTags } from './OrderTags';
import { OrderInfoContent } from './styles';
import { OrderTimeInfo } from './OrderTimeInfo';
import { OrderResourcesInfo } from './OrderResourcesInfo';
import { OrderNotesInfo } from './OrderNotesInfo';
import { OrderTitleInfo } from './OrderTitleInfo';
import { WithPreloaderHOC } from 'shared/ui/spinner';
import { useOrderState } from 'entities/orders/lib/hooks/order/useOrderState';
import { OrderTimeVisit } from './OrderTimeVisit';
import { format } from 'date-fns';
import { Typography } from 'shared/ui/typography';
// import { Flex } from 'shared/ui/flex';
// import { TextCard } from 'shared/ui/cards/textCard';
import { BookingDepositeInfo } from 'features/booking/BookingDeposite/ui/components/Info';

interface OrderInfoProps extends WithPreloaderHOC {
	order: Order | null;
	includeContactInfo?: boolean;
	title?: string;
  isModal?: boolean;
}

export const OrderInfoShort: FC<OrderInfoProps> = ({
	order,
	includeContactInfo = true,
	title = 'Бронирование',
}) => {
	const { isVisitEnd, isCanceled } = useOrderState(order);

	const dateCreated = order ? new Date(order.dt_created) : null;

	return (
		<OrderInfoContent>
			<OrderTitleInfo order={order} title={title} showConfirm={false} />
			{dateCreated && (
				<Typography mode="smaller" style={{ marginBottom: '16px' }}>
					Создано {format(dateCreated, 'dd.MM.yyyy')} в {format(dateCreated, 'HH:mm')}
				</Typography>
			)}
			<OrderTimeInfo order={order} />
			{isVisitEnd && !isCanceled && <OrderTimeVisit order={order} />}
			{!isCanceled && (
				<OrderResourcesInfo appointment={order?.appointment} conflicts={order?.conflicts} />
			)}
			<OrderNotesInfo order={order} />
			<OrderTags tags={order?.tags} forOrder={true} outputDashInsteadTags />
      <BookingDepositeInfo 
        deposit={order?.deposit}
      />

			{order?.person && includeContactInfo && (
				<div>
					<OrderPersonInfo person={order?.person} />
				</div>
			)}
		</OrderInfoContent>
	);
};
